document.addEventListener('DOMContentLoaded', function () {
    const gauges = document.querySelectorAll('[gauges]');
    Array.from(gauges).forEach(gauge => {
        renderGauge(gauge.getAttribute('id'), parseInt(gauge.getAttribute('gauges')));
    });

    changeHeaderBg();

    function changeHeaderBg() {
        let header = document.querySelector('#header');

        header.classList.add('bg-dark');
        header.classList.add('position-unset');
    }

    function renderGauge(containerId, gaugeValue) {
        Highcharts.chart(containerId, {
            chart: {
                type: 'gauge',
                backgroundColor: 'transparent',
                plotBorderWidth: 0,
                plotShadow: false
            },

            title: null,

            pane: {
                startAngle: -90,
                endAngle: 90,
                background: null,
                center: ['50%', '50%'],
                size: '110%'
            },

            yAxis: {
                min: 0,
                max: 800,
                tickInterval: 100,
                tickPositions: [0, 200, 400, 600, 800],
                tickWidth: 2,
                minorTickLength: 5,
                lineWidth: 1,
                labels: {
                    distance: -35,
                    style: {
                        color: '#fff',
                        fontSize: '9px',
                        fontWeight: '400'
                    }
                },
                plotBands: [{
                    from: 0,
                    to: 800,
                    color: '#EEEEEE',
                    thickness: '20%'
                }, {
                    from: 0,
                    to: gaugeValue,
                    color: {
                        linearGradient: { x1: 0, y1: 0, x2: 0, y2: 0 },
                        stops: [[0, '#5B9ED6']]
                    },
                    thickness: '20%'
                }]
            },

            series: [{
                name: 'Valor',
                data: [gaugeValue],
                tooltip: {
                    valueSuffix: ' RPM'
                }
            }],

            plotOptions: {
                gauge: {
                    dial: {
                        backgroundColor: '#5B9ED6',
                        baseLength: '30%',
                        baseWidth: 9,
                        rearLength: 4,
                        topWidth: 3
                    },
                    pivot: {
                        backgroundColor: '#fff',
                        radius: 10
                    }
                }
            }
        });
    }

    // swipers
    const swiperPreview = new Swiper('.swiper-preview', {
        slidesPerView: "auto",
        loop: false,
        spaceBetween: 6,
        freeMode: true,
        watchSlidesProgress: true,
    })

    const swiperProduct = new Swiper('.swiper-product', {
        slidesPerView: 1,
        loop: true,
        spaceBetween: 20,
        speed: 900,

        thumbs: {
            swiper: swiperPreview,
        },
    });

    const swiperMost = new Swiper(".swiper-most", {
        slidesPerView: 1,
        spaceBetween: 20,
        centeredSlides: true,
        loop: true,
        speed: 1000,

        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            992: {
                slidesPerView: "auto",
                spaceBetween: 253,
            },
        }
    });
})